<!-- Navbar -->
<app-navbar></app-navbar>

<!-- Content Section -->
<div class="container-fluid overflow-auto dashboard-content driver-management__container px-0">
  <div class="operations-dashboard__wrapper">
    <div class="operations-dashboard__row">
      <app-sidebar></app-sidebar>
      <div class="operations-dashboard__body">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<!-- scripts -->